<template>
	<Vector :src="bgImage" class="svg-bg" :style="{ backgroundColor: baseColor, fill: fillColor }" />
</template>

<script>
import Vector from '@/components/abstract/Vector';
import tinycolor from 'tinycolor2';

export default {
	name: 'StageBackground',
	components: {
		Vector,
	},
	props: ["settings"],
	computed: {
		bgImage() {
			return `${this.settings.background.sizes.large}`;
		},
		baseColor() {
			return this.modifyColor(
				this.$store.state.board.baseColor,
				this.settings.colors[this.$store.state.cats.selectionKey].background.hue,
				this.settings.colors[this.$store.state.cats.selectionKey].background.darken,
				this.settings.colors[this.$store.state.cats.selectionKey].background.desaturate,
			);
		},
		fillColor() {
			return this.modifyColor(
				this.$store.state.board.baseColor,
				this.settings.colors[this.$store.state.cats.selectionKey].pattern.hue,
				this.settings.colors[this.$store.state.cats.selectionKey].pattern.darken,
				this.settings.colors[this.$store.state.cats.selectionKey].pattern.desaturate,
			);
		},
	},
	methods: {
		modifyColor(color, spin, darken, desaturate) {
			return tinycolor(color)
				.darken(darken)
				.spin(spin)
				.desaturate(desaturate)
				.toString();
		},
	},
};
</script>

<style lang="scss" scoped>
	.svg-bg {
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;

		svg {
			height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/board/StageBackground.vue